<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>字典名称：</label>
            <a-input
              placeholder="请输入"
              v-model="dataDicValue"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="datas"
          :rowKey="(record) => record.dicCode"
          size="small"
          :scroll="{ y: datas.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="() => checkMethod(record.dicCode)"
            >
              查看
            </a>
          </span>
        </a-table>
      </div>
    </div>
    <a-modal
      title="字典项列表"
      v-model="childVisible"
      width="1000px"
      :footer="false"
      :maskClosable="false"
    >
      <template>
        <a-button type="primary" @click="addDataDic"> 添加 </a-button>
        <div class="table_box">
          <a-table
            :pagination="false"
            :columns="columns"
            :dataSource="childDatas"
            :rowKey="(record) => record.dicCode"
            size="small"
            bordered
          >
            <span slot="operator" slot-scope="text, record">
              <a href="javascript:void(0);" @click="() => editDataDic(record)">
                编辑
              </a>
            </span>
          </a-table>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="字典项"
      v-model="editVisible"
      width="600px"
      @cancel="cancel"
      @ok="enSure"
      :maskClosable="false"
    >
      <template>
        <div class="dataDic-edit">
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>字典项名称：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="dataDicInfo.dicValue"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>排序号：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="dataDicInfo.sort"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">说明：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="dataDicInfo.note"
              />
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
  </div>
</template>


<script>
const columns = [
  {
    title: "字典编码",
    dataIndex: "dicCode",
  },
  {
    title: "字典名称",
    dataIndex: "dicValue",
  },
  {
    title: "排序号",
    dataIndex: "sort",
  },
  {
    title: "说明",
    dataIndex: "note",
  },
  {
    title: "操作",
    dataIndex: "",
    key: "x",
    scopedSlots: { customRender: "operator" },
  },
];

export default {
  name: "DataDic",
  components: {
    // "check-role":checkRole
  },
  data() {
    return {
      dataDicValue: "",
      datas: [],
      columns,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      childVisible: false,
      currParent: "",
      childDatas: [],
      editVisible: false,
      dataDicInfo: {},
    };
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    query() {
      this.axios
        .get("/dataDic/queryDataDicRoot", {
          params: {},
        })
        .then((res) => {
          if (res.data) {
            this.datas = res.data;
          } else {
            this.utils.messageInfo(this, "error", "查询字典失败！");
          }
        });
    },
    checkMethod(dicCode) {
      this.currParent = dicCode;
      this.axios
        .get("/dataDic/queryChild", {
          params: { parentCode: dicCode },
        })
        .then((res) => {
          if (res.data) {
            this.childDatas = res.data;
          } else {
            this.utils.messageInfo(this, "error", "查询字典失败！");
          }
        });
      this.childVisible = true;
    },
    addDataDic() {
      this.dataDicInfo = {
        dicValue: "",
        sort: this.childDatas.length + 1,
        note: "",
        parentCode: this.currParent,
      };
      this.editVisible = true;
    },
    editDataDic(record) {
      this.dataDicInfo = {
        dicCode: record.dicCode,
        dicValue: record.dicValue,
        sort: record.sort,
        note: record.note,
        status: record.status,
        parentCode: record.parentCode,
      };
      this.editVisible = true;
    },
    cancel() {
      this.editVisible = false;
    },
    enSure() {
      if (this.dataDicInfo.dicValue == "") {
        this.utils.messageInfo(this, "error", "字典项名称不能为空！");
        return;
      }
      if (this.dataDicInfo.dicCode) {
        this.axios
          .post("/dataDic/updateDataDic", {
            dicCode: this.dataDicInfo.dicCode,
            dicValue: this.dataDicInfo.dicValue,
            sort: this.dataDicInfo.sort,
            note: this.dataDicInfo.note,
            parentCode: this.dataDicInfo.parentCode,
            status: this.dataDicInfo.status,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.checkMethod(this.currParent);
              this.editVisible = false;
            } else {
              this.utils.messageInfo(this, "error", "编辑失败！");
            }
          });
      } else {
        this.axios
          .post("/dataDic/saveDataDic", {
            dicCode:
              this.dataDicInfo.parentCode +
              "_" +
              this.padding1(this.childDatas.length + 1, 3),
            dicValue: this.dataDicInfo.dicValue,
            sort: this.dataDicInfo.sort,
            note: this.dataDicInfo.note,
            parentCode: this.dataDicInfo.parentCode,
            status: 1,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.checkMethod(this.currParent);
              this.dataDicInfo = {};
              this.editVisible = false;
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      }
    },
    padding1(num, length) {
      for (var len = (num + "").length; len < length; len = num.length) {
        num = "0" + num;
      }
      return num;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.dataDic-edit .ant-row {
  margin-bottom: 10px;
}
.dataDic-edit .title {
  text-align: right;
  line-height: 32px;
}
</style>
